import request from '@/utils/http';
import utils from '@/utils/common';
const apiCrmHost = 'api-lcrm';

// 数据处理中心查询接口
export const getListApi = (data) => {
    return request({
        url: apiCrmHost + '/contract/info/page', // 非权限控制
        method: 'post',
        data
    });
};

// 数据处理中心列表单条数据删除
export const deleteApi = (data) => {
    return request({
        url: apiCrmHost + '/contract/info/remove',
        method: 'DELETE',
        data
    });
};

// 根据数据处理中心查询详情
export const getByContractCodeApi = (params) => {
    return request({
        url: apiCrmHost + '/contract/info/getByContractCode',
        method: 'get',
        params
    });
};

// 数据处理中心列表导出鉴权接口
export const getUserDataAuthsApi = (params) => {
    return request({
        url: apiCrmHost + '/getUserRoleAndDataAuths',
        method: 'get',
        params
    });
};

// 数据处理中心运维导出接口
export const contractInfoAsyncExport = (data) => {
    return request({
        url: apiCrmHost + '/contract/info/export/async',
        method: 'post',
        data
    });
};
// 数据处理中心-下载模版-xsh
export const respTemplateDownloadApi = (data) => {
    return request({
        url: apiCrmHost + '/resp/dataManage/file/download',
        method: 'post',
        responseType: 'blob',
        data
    }).then(res => {
        utils.downloadStream(res, data.fileName);
    });
};
// 数据处理中心-删除下载模版-xsh
export const respTemplateDeleteDownloadApi = (data) => {
    return request({
        url: apiCrmHost + '/resp/dataManage/fileDelete/download',
        method: 'post',
        responseType: 'blob',
        data
    }).then(res => {
        utils.downloadStream(res, data.fileName);
    });
};
// 数据处理中心-获取详情-wy
export const getResponsibleDetail = (params) => {
    return request({
        url: apiCrmHost + '/resp/dataManage/detail',
        method: 'get',
        params
    });
};
// 数据处理中心-保存详情-wy
export const saveResponsibleDetail = (data) => {
    return request({
        url: apiCrmHost + '/resp/dataManage/save',
        method: 'post',
        data
    });
};
// 数据处理中心-提交审批-yjl
export const sumbitResponsibleFlow = (params) => {
    return request({
        url: apiCrmHost + '/resp/dataManage/submit',
        method: 'get',
        params
    });
};
// 数据处理中心-上传文件校验
export const checkImportResponsible = (data) => {
    return request({
        url: apiCrmHost + '/resp/dataManage/importCheck',
        method: 'post',
        data
    });
};
